import type { RGB } from '../type';

// This function calculates the colour at a given point on the canvas.
// It gets the RGB values at that point and returns them.
// It takes the canvas reference, as well as the x and y coordinates of the point.
// It calls the getRgbAtPoint function.
// This function is used to get the RGB values of a point on the canvas, for example when the user is selecting a colour.

export const calculateColourAtPoint = (
    posX: number,
    posY: number,
    canvasRef: HTMLCanvasElement
) => getRgbAtPoint(canvasRef, posX, posY);

/**
 * Returns the RGB color at a given point on a canvas.
 *
 * @param canvas - The canvas element to get the color from.
 * @param left - The x coordinate of the point.
 * @param top - The y coordinate of the point.
 * @returns The RGB color at that point.
 */

const getRgbAtPoint = (
    canvas: HTMLCanvasElement,
    left: number,
    top: number
): RGB | null => {
    const context = canvas.getContext('2d', { willReadFrequently: true });

    const data = context?.getImageData(left, top, 1, 1).data;

    return data
        ? {
              r: data[0] ?? 0,
              g: data[1] ?? 0,
              b: data[2] ?? 0,
          }
        : null;
};
